module.exports = __webpack_public_path__ + "static/media/location-distance.0d92c493.svg";